// prop-types linter doesn't like the airbnb-prop-types wrapper:
/* eslint react/prop-types:"off" */

import React from 'react';
import PropTypes from 'prop-types';

import { forbidExtraProps } from 'airbnb-prop-types';
import cx from 'classnames';

import ScrollableOrientationShape from 'react-dates/lib/shapes/ScrollableOrientationShape';

import './PickerNavigation.scss';

import {
  HORIZONTAL_ORIENTATION,
  VERTICAL_SCROLLABLE,
} from 'react-dates/constants';

const propTypes = forbidExtraProps({
  navPrev: PropTypes.node,
  navNext: PropTypes.node,
  orientation: ScrollableOrientationShape,
  isVertical: PropTypes.bool,

  onPrevClick: PropTypes.func,
  onNextClick: PropTypes.func,
});

const defaultProps = {
  navPrev: null,
  navNext: null,
  orientation: HORIZONTAL_ORIENTATION,

  onPrevClick() {},
  onNextClick() {},
};

export default function PickerNavigation(props) {
  const {
    navPrev,
    navNext,
    onPrevClick,
    onNextClick,
    orientation,
  } = props;

  const isVertical = orientation !== HORIZONTAL_ORIENTATION;
  const isVerticalScrollable = orientation === VERTICAL_SCROLLABLE;

  const navClassNames = cx('PickerNavigation', {
    'PickerNavigation--horizontal': !isVertical,
    'PickerNavigation--vertical': isVertical,
    'PickerNavigation--vertical-scrollable': isVerticalScrollable,
  });

  return (
    <div className={navClassNames}>
      {!isVerticalScrollable &&
        <button className='PickerNavigation__prev' onClick={onPrevClick}>
          {navPrev || <i className="material-icons">arrow_back</i>}        
        </button>
      }

      <button className='PickerNavigation__next' onClick={onNextClick}>
        {navNext || <i className="material-icons">arrow_forward</i>}        
      </button>
    </div>
  );
}

PickerNavigation.propTypes = propTypes;
PickerNavigation.defaultProps = defaultProps;
